import { LogOut, Mail, ShieldCheck } from "lucide-react";

import { usePortal } from "@/features/portal/portal-context";
import { PopinMark } from "@/components/popin-mark";
import { Button } from "@/components/ui/button";

const PARTNER_EMAIL = "hello@pop.in";

/**
 * Shown when a user is signed in to Firebase but has no portal access — they're
 * not a pop.in partner and aren't a member of any brand. We keep them signed in
 * (so they can return after requesting access) and explain how to get in. They
 * leave via the explicit sign-out button.
 */
export function PartnersOnlyPage() {
  const { logout } = usePortal();

  return (
    <div className="grid min-h-screen place-items-center bg-background px-6 text-foreground">
      <div className="flex max-w-[480px] flex-col items-center gap-5 text-center">
        <PopinMark size={34} />

        <div className="grid size-14 place-items-center rounded-2xl border border-border bg-card">
          <ShieldCheck className="size-7 text-brand" />
        </div>

        <div className="space-y-3">
          <h1 className="text-xl font-extrabold tracking-[-.02em]">
            The Partner Portal is for pop.in partners
          </h1>
          <p className="text-sm leading-relaxed text-muted-foreground">
            You’re signed in, but this account doesn’t have access yet. The portal is where pop.in
            partners white-label and configure their own apps.
          </p>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Want to become a partner? Email{" "}
            <a className="font-semibold text-brand hover:underline" href={`mailto:${PARTNER_EMAIL}`}>
              {PARTNER_EMAIL}
            </a>
            . Already part of a partnership? Ask whoever administers it to grant your account access.
          </p>
        </div>

        <div className="flex items-center gap-2.5 pt-1">
          <Button asChild>
            <a href={`mailto:${PARTNER_EMAIL}`}>
              <Mail className="size-4" /> Email {PARTNER_EMAIL}
            </a>
          </Button>
          <Button variant="ghost" onClick={logout}>
            <LogOut className="size-4" /> Sign out
          </Button>
        </div>
      </div>
    </div>
  );
}
